import { TRegion } from '@typescript/index';
import { getRegion } from '@utils/misc';

export interface ICurrencyData {
  symbol: string;
  isCurrencyInFront: boolean;
}

const getSeparatorByRegion = (region: TRegion): string => {
  switch (region) {
    case 'EN':
      return ',';
    case 'MX':
    case 'PL':
    default:
      return ' ';
  }
};

const getSubSeparatorByRegion = (region: TRegion): string => {
  switch (region) {
    case 'MX':
    case 'EN':
      return '.';
    case 'PL':
    default:
      return ',';
  }
};

export const getCurrencySymbolByCurrency = (currency: string): ICurrencyData => {
  switch (currency) {
    case 'MXN':
      return { symbol: '$', isCurrencyInFront: true };
    case 'PLN':
      return { symbol: 'zł', isCurrencyInFront: false };
    case 'EUR':
      return { symbol: '€', isCurrencyInFront: false };
    default:
      return { symbol: '', isCurrencyInFront: false };
  }
};

export const getCurrencyByRegion = (region: string): string => {
  switch (region) {
    case 'MX':
      return 'MXN';
    case 'PL':
      return 'PLN';
    case 'ES':
    case 'DE':
    case 'EUR':
      return 'EUR';
    default:
      return '';
  }
};

export const formatPrice = (price: number, currency?: string): string => {
  const region = getRegion('uppercase') as TRegion;
  const priceString = (Math.round((price + Number.EPSILON) * 100) / 100).toString();
  const stringPrice: string = priceString.length <= 2 ? `0${priceString}` : priceString;
  const mainPrice: string = stringPrice.substring(0, stringPrice.length - 2);
  const subPrice: string = stringPrice.substring(stringPrice.length - 2, stringPrice.length);
  const separator: string = getSeparatorByRegion(region);
  const subSeparator: string = getSubSeparatorByRegion(region);
  const parsedCurrency = currency || getCurrencyByRegion(region);
  const { symbol, isCurrencyInFront } = getCurrencySymbolByCurrency(parsedCurrency);

  let buildPriceString: string;

  if (priceString === '0') {
    buildPriceString = '0';
  } else {
    buildPriceString =
      subPrice === '00'
        ? mainPrice.replace(/\B(?=(\d{3})+(?!\d))/g, separator)
        : `${mainPrice.replace(/\B(?=(\d{3})+(?!\d))/g, separator)}${subSeparator}${subPrice}`;
  }

  const finalPriceString: string = isCurrencyInFront
    ? `${symbol} ${buildPriceString}`
    : `${buildPriceString} ${symbol}`;

  return finalPriceString;
};

export const currencySymbolToISO = (symbol: string): string => {
  switch (symbol) {
    case '$':
      return 'USD';
    case '€':
      return 'EUR';
    case 'zł':
      return 'PLN';
    case '£':
      return 'GBP';
    default:
      return symbol;
  }
};

export default formatPrice;
